exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-container[data-v-3338545a]{display:-webkit-box;display:-ms-flexbox;display:flex}.select-container .label[data-v-3338545a]{display:inline-block;padding:0 20px;width:120px;height:40px;text-align:left;line-height:40px;border-top:1px solid #dcdfe6;border-left:1px solid #dcdfe6;border-bottom:1px solid #dcdfe6;border-radius:4px 0 0 4px;color:#909399;background-color:#f5f7fa;font-weight:bold}.select-container .select[data-v-3338545a]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}\n", ""]);

// exports
